// extracted by mini-css-extract-plugin
module.exports = {"shadow":"StyledCell_shadow__3ZvBq","cellStyling":"StyledCell_cellStyling__1cZoN"};